import { render, staticRenderFns } from "./MarketplaceChallanList.vue?vue&type=template&id=6cb9e78b&scoped=true&"
import script from "./MarketplaceChallanList.vue?vue&type=script&lang=js&"
export * from "./MarketplaceChallanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb9e78b",
  null
  
)

export default component.exports